module.exports = __webpack_public_path__ + "img/Scorecard.da793149.jpg";